/* eslint-disable max-len */
import React from "react";
import { string } from "prop-types";

const NewsLetterIcon = ({ width = "49", height = "49" }) => {
  return (
    <svg
      id="Newsletter_icon_1"
      data-name="Newsletter icon_1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 64"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_60"
            data-name="Rectangle 60"
            width="31.542"
            height="30.302"
            transform="translate(0 0)"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <circle id="Ellipse_5" data-name="Ellipse 5" cx="32" cy="32" r="32" fill="#ededec" />
      <circle id="Ellipse_7" data-name="Ellipse 7" cx="26" cy="26" r="26" transform="translate(6 6)" fill="#bababa" />
      <g id="Group_77" data-name="Group 77" transform="translate(16.229 14.845)">
        <g id="Group_76" data-name="Group 76" transform="translate(0 0.004)" clipPath="url(#clip-path)">
          <path
            id="Path_67"
            data-name="Path 67"
            d="M137.523,132.389c0-.844,0-1.656,0-2.467q0-.737,0-1.474c0-.255.006-.51.006-.766q0-1.631,0-3.263a1.935,1.935,0,0,1,.644-1.51,1.879,1.879,0,0,1,1.282-.518q9.334,0,18.668,0a1.962,1.962,0,0,1,1.979,1.967q0,3.419,0,6.837c0,.378,0,.756,0,1.134a.7.7,0,0,0,.053.243c.074.184.071.246-.08.362-.186.143-.378.278-.572.41-.387.263-.778.521-1.165.783-.273.185-.542.374-.813.562a1.275,1.275,0,0,0-.158.119,5.6,5.6,0,0,1-1.168.826,4.2,4.2,0,0,0-.639.463,15.954,15.954,0,0,1-1.589,1.13c-.529.344-1.023.74-1.538,1.106-.645.459-1.28.934-1.948,1.357a2.512,2.512,0,0,1-1.8.318,2.951,2.951,0,0,1-1.282-.56c-.746-.545-1.5-1.07-2.252-1.612-.594-.431-1.2-.837-1.807-1.255-.666-.462-1.307-.959-1.962-1.436-.165-.12-.347-.217-.512-.338-.494-.361-.979-.734-1.476-1.092-.3-.213-.614-.4-.912-.609-.336-.238-.662-.491-.965-.717m13.287-.623c.081.1.143.165.2.238a1.741,1.741,0,0,0,1.829.495,2.19,2.19,0,0,0,.9-.7,2.371,2.371,0,0,0,.419-1.122,5.239,5.239,0,0,0-.085-2.382,4.676,4.676,0,0,0-.367-.914,4.452,4.452,0,0,0-2.82-2.193,5.948,5.948,0,0,0-1.316-.117,4.628,4.628,0,0,0-1.767.333,5.8,5.8,0,0,0-1.649.963,5.949,5.949,0,0,0-1.854,2.657,4.665,4.665,0,0,0-.267,1.72,3.424,3.424,0,0,0,.04.7,4.074,4.074,0,0,0,.51,1.422,3.967,3.967,0,0,0,.635.924c.109.091.22.179.324.274a4.023,4.023,0,0,0,1.7.912,5.581,5.581,0,0,0,1.109.2,5.367,5.367,0,0,0,1.154-.063,5.156,5.156,0,0,0,.967-.278,3.739,3.739,0,0,0,.729-.357.4.4,0,0,0,.019-.687c-.181-.151-.355-.14-.619.025-.118.074-.246.132-.368.2a3.032,3.032,0,0,1-1.04.243,2.914,2.914,0,0,1-1.476-.045,6.421,6.421,0,0,1-1.25-.5,2.609,2.609,0,0,1-.7-.6,3.928,3.928,0,0,1-.762-1.558,4.006,4.006,0,0,1,.092-2.121,4.934,4.934,0,0,1,4.669-3.5,3.6,3.6,0,0,1,2.6,1.057,3.468,3.468,0,0,1,.992,2.337,8.876,8.876,0,0,1-.1,1.378,1.026,1.026,0,0,1-.682.9c-.548.217-1.121.021-1.081-.686.025-.432.092-.861.147-1.29.063-.485.137-.969.2-1.455a.5.5,0,0,0-.381-.5.429.429,0,0,0-.494.357c-.015.061-.036.12-.064.213-.083-.055-.144-.091-.2-.135a1.927,1.927,0,0,0-.837-.4,2.577,2.577,0,0,0-2.125.541,2.816,2.816,0,0,0-1.009,1.59,2.175,2.175,0,0,0,.43,1.887,1.926,1.926,0,0,0,1.512.809,2.564,2.564,0,0,0,1.973-.671,1.929,1.929,0,0,1,.158-.116"
            transform="translate(-133.387 -118.71)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_68"
            data-name="Path 68"
            d="M33.282,704.737c.106-.243,11.38-8.621,11.8-8.909.324.227.656.455.984.69a3.219,3.219,0,0,0,1.158.5,3.7,3.7,0,0,0,1.01.085,3.237,3.237,0,0,0,1.727-.55c.343-.233.678-.477,1.043-.736.992.717,1.973,1.463,2.956,2.2s1.97,1.488,2.959,2.226,1.979,1.448,2.953,2.192,1.988,1.454,2.961,2.248a2.475,2.475,0,0,1-1.426.49c-.69-.006-1.38.016-2.069.016q-12.14,0-24.28,0a3.268,3.268,0,0,1-1.168-.155,6.443,6.443,0,0,1-.611-.3"
            transform="translate(-32.281 -674.894)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_69"
            data-name="Path 69"
            d="M659.3,411.268l-11.642-8.72,11.995-8.536a.458.458,0,0,1,.057.138c0,.358.014.716-.011,1.072a11.254,11.254,0,0,0,.025,1.176c0,.13-.025.261-.029.393s.008.281.006.421c-.006.566-.014,1.133-.021,1.7-.005.431.027.86.043,1.29a2.973,2.973,0,0,1-.05.444.954.954,0,0,0-.01.14c.013.377.038.754.039,1.131q.005,4.112,0,8.223a2.409,2.409,0,0,1-.279,1c-.022.048-.074.081-.124.133"
            transform="translate(-628.178 -382.164)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_70"
            data-name="Path 70"
            d="M.056,394.209c1.331.964,2.663,1.9,3.986,2.839S6.7,398.889,8,399.845s2.647,1.892,4,2.867a1.706,1.706,0,0,1-.185.192c-.488.371-.979.737-1.47,1.1q-.916.688-1.833,1.375c-.975.728-1.953,1.451-2.926,2.181-.641.481-1.274.973-1.914,1.455-.406.306-.822.6-1.229.9-.672.5-1.34,1.007-2.043,1.536a.944.944,0,0,1-.17-.222A2.845,2.845,0,0,1,.016,410.2c.016-2.865.011-5.73.007-8.595,0-1.3-.017-2.608-.023-3.912,0-.169.02-.338.028-.508,0-.055-.009-.11-.009-.166,0-.319-.007-.637-.008-.956,0-.074.015-.149.014-.223C.019,395.323.01,394.8,0,394.286c0-.015.019-.03.052-.077"
            transform="translate(0 -382.355)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_71"
            data-name="Path 71"
            d="M380.923,2.758c-.248.069-7.459.106-8.843.048a2.023,2.023,0,0,1-.245-.048l.486-.365c.812-.613,1.632-1.215,2.433-1.842a2.778,2.778,0,0,1,3.479.127c.432.35.888.67,1.333,1s.888.668,1.331,1c.012.009.013.034.026.073"
            transform="translate(-360.654 -0.004)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_72"
            data-name="Path 72"
            d="M917.945,280.183c-.034-.058-.059-.081-.059-.1q0-2.53.006-5.061c0-.014.023-.028.053-.064,1.17.9,2.365,1.763,3.552,2.7l-3.552,2.531"
            transform="translate(-890.284 -266.686)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_73"
            data-name="Path 73"
            d="M10.455,293.359c.954-.758,1.918-1.457,2.909-2.206a1.217,1.217,0,0,1,.061.254q0,1.884-.016,3.769c0,.072,0,.144,0,.221a27.521,27.521,0,0,1-2.955-2.038"
            transform="translate(-10.141 -282.398)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_74"
            data-name="Path 74"
            d="M472.248,330.509a1.2,1.2,0,0,1-1.131-.6,1.249,1.249,0,0,1-.17-.869,1.883,1.883,0,0,1,1.382-1.585,1.45,1.45,0,0,1,1.2.133,1.1,1.1,0,0,1,.358.351,1.438,1.438,0,0,1,.08,1.43,1.931,1.931,0,0,1-1.721,1.143"
            transform="translate(-456.768 -317.535)"
            fill="#fff"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

NewsLetterIcon.propTypes = {
  width: string,
  height: string,
};

export default NewsLetterIcon;
